 
 
<template>
  <div>
    <j-select-biz-component :width="1000" ref="bizModal" returnId v-bind="configs" v-on="$listeners">
      <a-button @click="handleAdd" class="ml-8px" icon="plus" slot="action" type="primary" v-if="openCreate">新增</a-button>
    </j-select-biz-component>
    <facturer-modal @ok="modalFormOk" ref="modalForm" />
  </div>
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'
  import FacturerModal from '@/views/equipment/account/vue/modules/CommonManufacturerModal'

  export default {
    name: 'JSelectDeviceFacturer',
    components: { JSelectBizComponent, FacturerModal },
    props: {

      value: {
        type: String,
        default: ''
      },
      // settings: {
      //   type: Object,
      //   default: () => { }
      // },
      openCreate: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        settings: {
          name: '生产厂家',
          displayKey: 'manuName',
          valueKey: 'id',
          returnKeys: ['id', 'manuName'],
          listUrl: '/device/commonManufacturer/list',
          queryParamCode: 'manuName',
          queryParamText: '厂家名称',
          ellipsisLength: -1,
          columns: [
            { title: '厂家名称', dataIndex: 'manuName', align: 'center', width: '100%', widthRight: '70%' },
            // devCode
          ]

        }
      }
    },
    created () {

    },
    computed: {
      configs () {
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      }
    },
    created () {

    },
    methods: {
      modalFormOk (id) {
        this.$emit('modeAddEnd', id)
        this.$refs.bizModal.visible = false
      },
      handleAdd: function () {
        this.$refs.modalForm.add()
        this.$refs.modalForm.title = '新增'
        this.$refs.modalForm.disableSubmit = false
      },
    }
  }
</script>

<style lang="less" scoped></style>
